import React from "react";
import { MultiSelect } from "react-multi-select-component";
import DropdownArrowDown from "./img/dropdownArrow-Down.svg";
import DropdownCloseIcon from "./img/close-icon.svg";

const DefaultArrow = ({ expanded }) => (
  <img
    src={DropdownArrowDown}
    width={10}
    alt=""
    className={expanded ? "sw-arrow-open" : "sw-arrow-close"}
  />
);

const DefaultClearIcon = () => (
  <img src={DropdownCloseIcon} width={12} alt="" />
);

const defaultValueRenderer = (selected, options, placeholder) => {
  if (selected.length === 0) return placeholder;
  if (selected.length === options.length) return "All items selected";
  return `${selected.length} item${selected.length > 1 ? "s" : ""} selected`;
};

const SwMultiSelect = ({
  /* Core */
  options = [],
  value = [],
  onChange,

  /* UI */
  placeholder = "Select options",
  labelledBy = "Select options",
  disabled = false,

  /* Custom renderers */
  valueRenderer,
  ArrowRenderer,
  ClearIcon,

  /* Styling */
  containerClass = "SwMultiselect",
  className = "",

  /* Forwarded */
  ...rest
}) => {
  return (
    <MultiSelect
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      labelledBy={labelledBy}
      ArrowRenderer={ArrowRenderer || DefaultArrow}
      ClearIcon={ClearIcon || <DefaultClearIcon />}
      ClearSelectedIcon={ClearIcon || <DefaultClearIcon />}
      valueRenderer={(selected, opts) =>
        valueRenderer
          ? valueRenderer(selected, opts)
          : defaultValueRenderer(selected, opts, placeholder)
      }
      className={`${containerClass} ${className}`}
      {...rest}
    />
  );
};

export default SwMultiSelect;
